import axios from "axios";


const $axios = axios.create({
    baseURL: "http://www.cqzxyatai.com/ps/site/",
    // baseURL: "http://192.168.228.114:80/ps/site",
    // baseURL: "http://139.9.216.171:10000/ps/site",
    headers: {
        'Content-Type': 'application/json;charset=utf8'
    }
});

// 添加请求拦截器
$axios.interceptors.request.use(function (config) {
    config.headers.common['X-Access-Token'] = window.localStorage.getItem('token');
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
$axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么


    if (response.data.status_code == 405) {

    }

    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default $axios